var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAvailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18a9 9 0 119-9 8.99 8.99 0 01-9 9zm4.014-10.051l-4.4 4.134c-.15.149-.359.233-.577.233s-.427-.084-.577-.233L4.984 9.758a.685.685 0 01-.247-.542.74.74 0 01.237-.552.838.838 0 01.588-.223c.22-.006.43.08.577.232l1.898 1.783 3.823-3.592a.885.885 0 01.577-.232.838.838 0 01.588.223.737.737 0 01.237.552.685.685 0 01-.247.543z",
    clipRule: "evenodd",
    fill: "#028702",
    fillRule: "evenodd"
  })));
}
export default SvgIconAvailable;